import { clsx } from 'clsx';
export function mergeStyles() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.reduce((result, styles) => {
    for (const key in styles) {
      if (styles.hasOwnProperty(key)) {
        result[key] = clsx(result[key], styles[key]);
      }
    }
    return result;
  }, {});
}